import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/observable/of';

import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

import * as actionsUi from './checklisten.actions.ui';
import {
    getAbarbeitenRollenSelektiert,
    getChecklisteDetail,
    getChecklisteListeUiSelektiert, getFreigabeRollenSelektiert,
    getFunktionsbereichListeUiSelektiert, getLeseRollenSelektiert,
    PageState
} from './checklisten.reducer';
import {flatMap, map, withLatestFrom} from 'rxjs/operators';
import {
    GET_CHECKLISTE_DETAIL_ERFOLGREICH,
    GetChecklisteAufgabenAction,
    GetChecklisteDetailErfolgreichAction, GetFunktionsbereicheRollenAction,
    PostChecklisteAktualisierenAction
} from '../../../client-ngrx/vorlagen';
import {Checkliste, ChecklisteDetail, ChecklisteModelRequest, Funktionsbereich} from '../../../clients/vorlagen';
import {getIstPandemieLizenzAktiv} from '@orga-app/mandant/reducer';
import {GetChecklistePandemieLevelInfoAction, PostAufgabePandemieLevelSetzenAction} from '../../../client-ngrx/pandemie';
import {AufgabeLevelRequest} from '../../../clients/pandemie';
import {PandemieLevelSetzenAction} from './checklisten.actions.ui';

@Injectable()
export class ChecklistenPageUiEffects {

    @Effect()
    pageReset$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET)
        , map((x) => {
            return new GetFunktionsbereicheRollenAction();
        })
    );

    @Effect()
    aktuelleChecklisteSetzen$: Observable<Action> = this.actions$.pipe(
        ofType(GET_CHECKLISTE_DETAIL_ERFOLGREICH)
        , withLatestFrom(this.store$.pipe(select(getIstPandemieLizenzAktiv)))
        , flatMap(([x, istPandemieLizenzAktiv]: [GetChecklisteDetailErfolgreichAction, boolean]) => {
                const actions: Array<Action> = [];
                actions.push(new GetChecklisteAufgabenAction(x.payload.checkliste_id));

                if (istPandemieLizenzAktiv) {
                    actions.push( new GetChecklistePandemieLevelInfoAction(x.payload.checkliste_id));
                }

                return actions;
            }
        ));
    @Effect()
    freigabeRollenLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.FREIGABE_ROLLEN_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getChecklisteDetail)), this.store$.pipe(select(getFreigabeRollenSelektiert)), this.store$.pipe(select(getFunktionsbereichListeUiSelektiert)))
        , flatMap(([x, checklisteDetail, rollenSelektiert, aktuellerFunktionsbereich]: [actionsUi.FreigabeRollenLoeschenAction, ChecklisteDetail, Array<string>, Funktionsbereich]) => {
            // console.log('aktuelleCheckliste', aktuelleCheckliste);
            const freigabeRollen = checklisteDetail.freigabe_rollen_ids.filter(y => rollenSelektiert.findIndex(z => y === z) === -1);
            const request = <ChecklisteModelRequest>{
                titel: checklisteDetail.titel,
                checkliste_id: checklisteDetail.checkliste_id,
                funktionsbereich_id: aktuellerFunktionsbereich.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now()),
                abarbeitung_rollen_ids: checklisteDetail.abarbeitung_rollen_ids,
                reihenfolge: checklisteDetail.reihenfolge,
                freigabe_rollen_ids: freigabeRollen,
                lese_rollen_ids: checklisteDetail.lese_rollen_ids
            };
            // console.log('asdsdasd', request, freigabeRollenSelected);
            return [
                new PostChecklisteAktualisierenAction(request)
            ];
        }));
    @Effect()
    abarbeitenRollenLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.ABARBEITEN_ROLLEN_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getChecklisteDetail)), this.store$.pipe(select(getAbarbeitenRollenSelektiert)), this.store$.pipe(select(getFunktionsbereichListeUiSelektiert)))
        , flatMap(([x, checklisteDetail, rollenSelektiert, aktuellerFunktionsbereich]: [actionsUi.AbarbeitenRollenLoeschenAction, ChecklisteDetail, Array<string>, Funktionsbereich]) => {
            // console.log('aktuelleCheckliste', aktuelleCheckliste);
            const abarbeitenRollen = checklisteDetail.abarbeitung_rollen_ids.filter(y => rollenSelektiert.findIndex(z => y === z) === -1);
            const request = <ChecklisteModelRequest>{
                titel: checklisteDetail.titel,
                checkliste_id: checklisteDetail.checkliste_id,
                funktionsbereich_id: aktuellerFunktionsbereich.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now()),
                abarbeitung_rollen_ids: abarbeitenRollen,
                reihenfolge: checklisteDetail.reihenfolge,
                freigabe_rollen_ids: checklisteDetail.freigabe_rollen_ids,
                lese_rollen_ids: checklisteDetail.lese_rollen_ids
            };
            return [
                new PostChecklisteAktualisierenAction(request)
            ];
        }));
    @Effect()
    lesenRollenLoeschen$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.LESE_ROLLEN_LOESCHEN)
        , withLatestFrom(this.store$.pipe(select(getChecklisteDetail)), this.store$.pipe(select(getLeseRollenSelektiert)), this.store$.pipe(select(getFunktionsbereichListeUiSelektiert)))
        , flatMap(([x, checklisteDetail, rollenSelektiert, aktuellerFunktionsbereich]: [actionsUi.LeseRollenLoeschenAction, ChecklisteDetail, Array<string>, Funktionsbereich]) => {
            // console.log('aktuelleCheckliste', aktuelleCheckliste);
            const leseRollen = checklisteDetail.lese_rollen_ids.filter(y => rollenSelektiert.findIndex(z => y === z) === -1);
            const request = <ChecklisteModelRequest>{
                titel: checklisteDetail.titel,
                checkliste_id: checklisteDetail.checkliste_id,
                funktionsbereich_id: aktuellerFunktionsbereich.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now()),
                abarbeitung_rollen_ids: checklisteDetail.abarbeitung_rollen_ids,
                reihenfolge: checklisteDetail.reihenfolge,
                freigabe_rollen_ids: checklisteDetail.freigabe_rollen_ids,
                lese_rollen_ids: leseRollen
            };
            return [
                new PostChecklisteAktualisierenAction(request)
            ];
        }));

    @Effect()
    pandemieLevelSetzen$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PANDEMIE_LEVEL_SETZEN)
        , withLatestFrom(this.store$.pipe(select(getChecklisteListeUiSelektiert)))
        , map( ([x, selCheckliste]: [PandemieLevelSetzenAction, Checkliste]) => {
            const request = <AufgabeLevelRequest>{
                aufgabe_id: x.payload.aufgabe_id,
                level_id: x.payload.level_id,
                level_setzen: x.wert,
                zeitpunkt_utc: new Date(),
                checkliste_id: selCheckliste.checkliste_id,
                funktionsbereich_id: selCheckliste.funktionsbereich_id
            };
            return new PostAufgabePandemieLevelSetzenAction(request);
        })
    );

    constructor(private actions$: Actions,
                private store$: Store<PageState>) {
    }
}
